/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import gatewayClient from '../helper/GatewayClient';

export const request = async (machineId, streamsheetId, reference, json) => {
	if (streamsheetId && reference) {
		try {
			const response = await gatewayClient.getCellRawValue(machineId, streamsheetId, reference);
			return response.machineserver ? JSON.parse(response.machineserver.rawvalue) : {};
		} catch (err) {
			/* ignore */
			json = {};
		}
	}
	return json;
};

const getValueAtKeySensitive = (key, json) => json[key];
const getValueAtKeyInSensitive = (key, json) => {
	key = key.toUpperCase();
	return json[Object.keys(json).find((k) => k.toUpperCase() === key)];
};
const getValueAt = (caseInSensitive) => {
	const getValue = caseInSensitive ? getValueAtKeyInSensitive : getValueAtKeySensitive;
	return (parent, key) => (parent != null && typeof parent === 'object' ? getValue(key, parent) : undefined);
};

export const valueAt = (path, json, caseInSensitive) => path.reduceRight(getValueAt(caseInSensitive), json);
